module.exports = __webpack_public_path__ + "static/media/ExportIcon.10491ac1.svg";